import RenewalVsTurnoverCalculator from './index';

const RenewalVsTurnoverCalculatorBlock = {
  Component: RenewalVsTurnoverCalculator,
  BlockRenderer: () => <RenewalVsTurnoverCalculator />,
  metadata: {
    name: 'rentals/renewal-vs-turnover-calculator',
    title: 'Renewal vs. Turnover Calculator',
    description: '',
    icon: 'businessperson',
    keywords: ['renewal', 'turnover', 'calculator', 'rentals'],
    supports: {
      customClassName: false,
      html: false,
    },
    category: 'more',
    attributes: {},
  },
};

export default RenewalVsTurnoverCalculatorBlock;
